module.exports = __webpack_public_path__ + "img/QRcode.a19024a5.jpg";